var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import { AiOutlineLoading } from 'react-icons/ai';
import { useLanguage } from '@base/LanguageProvider';
import { useTagActions } from '@data/tag/tagActions';
import ModalHeader from '@shared/modal/ModalHeader';
import { ModalBody } from '@styled/Modal';
import ModalFooter from '@shared/modal/ModalFooter';
function DeleteTag(_a) {
    var error = _a.error, loading = _a.loading, setLoading = _a.setLoading, target = _a.target, deleteType = _a.deleteType, bodyText = _a.bodyText, onDeleted = _a.onDeleted;
    var L = useLanguage().L;
    var _b = useTagActions(), deleteTagData = _b.deleteTagData, deleteTag = _b.deleteTag, deleteTagChildren = _b.deleteTagChildren;
    function deleteHandler() {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        if (!(deleteType === 'tag')) return [3 /*break*/, 3];
                        return [4 /*yield*/, deleteTag(target.id)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 3:
                        if (!(deleteType === 'children')) return [3 /*break*/, 5];
                        return [4 /*yield*/, deleteTagChildren(target.id)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        if (!(deleteType === 'data')) return [3 /*break*/, 7];
                        return [4 /*yield*/, deleteTagData(target.id)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        if (onDeleted) {
                            onDeleted();
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        err_1 = _a.sent();
                        alert(err_1.message);
                        console.log(err_1);
                        return [3 /*break*/, 9];
                    case 9:
                        setLoading(false);
                        Manager.closeModal();
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalBody, null, loading ? (React.createElement("div", { style: {
                display: 'flex',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement(AiOutlineLoading, { style: {
                    width: '20px',
                    height: '20px',
                    color: 'grey',
                    alignSelf: 'center',
                    animation: 'spinicon 1s linear infinite',
                } }))) : (React.createElement(React.Fragment, null, error ? React.createElement("div", { className: "red spacer-15 center" }, error) : React.createElement("div", null, bodyText)))),
        React.createElement(ModalFooter, { cancelLabel: L('Cancel'), done: deleteHandler, doneLabel: L('Delete'), doneColor: "error" })));
}
function DeleteTagModal(_a) {
    var _this = this;
    var target = _a.target, deleteType = _a.deleteType, _b = _a.onDeleted, onDeleted = _b === void 0 ? function () { } : _b;
    var L = useLanguage().L;
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(useState(''), 2), error = _d[0], setError = _d[1];
    if (deleteType === 'tag') {
        useEffect(function () {
            var checkForConflicts = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setLoading(true);
                    // TO DOOO !!!
                    //const connections = await get tag connections (target.id);
                    setLoading(false);
                    return [2 /*return*/];
                });
            }); };
            checkForConflicts();
        }, [target]);
    }
    var title = React.createElement(React.Fragment, null);
    if (deleteType === 'tag') {
        title = (React.createElement(React.Fragment, null,
            L('Delete'),
            ' ',
            React.createElement("b", null,
                target.name,
                " ",
                target.description),
            ' ',
            L('and related data'),
            "?"));
    }
    else if (deleteType === 'children') {
        title = (React.createElement(React.Fragment, null,
            L('Delete children of'),
            ' ',
            React.createElement("b", null,
                target.name,
                " ",
                target.description),
            ' ',
            "?"));
    }
    else if (deleteType === 'data') {
        title = (React.createElement(React.Fragment, null,
            L('Delete data for'),
            ' ',
            React.createElement("b", null,
                target.name,
                " ",
                target.description),
            ' ',
            "?"));
    }
    return (React.createElement(Modal, { height: "auto", width: "650", closeable: false },
        React.createElement(ModalHeader, { title: loading ? React.createElement(React.Fragment, null) : title }),
        React.createElement(DeleteTag, { onDeleted: onDeleted, loading: loading, error: error, target: target, deleteType: deleteType, bodyText: title, setLoading: setLoading })));
}
export default DeleteTagModal;
